import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '../../../shared/services/configuration.service';
import { DataHandlerService } from '../../../shared/services/data-handler.service';
import { ActivityInfo } from '../../calendars/calendars.models';


@Injectable()

export class CampaignAssignerService
{
  private dataHandler = inject(DataHandlerService);
  public configurationService = inject(ConfigurationService);

  private _unassignedActivitiesForClient: ActivityInfo[] = [];


  constructor()
  {

  }
  get unassignedActivitiesForClient(): ActivityInfo[]
  {
    return this._unassignedActivitiesForClient;
  }
  set unassignedActivitiesForClient(value: ActivityInfo[])
  {
    this._unassignedActivitiesForClient = value;
  }







}
